/**
 * Qawaem licensing worker base URL.
 * Local dev (3000 Qawaem / 3001 legacy): same-origin + src/setupProxy.js → Cloudflare worker (avoids CORS).
 */
const DEFAULT_WORKER = 'https://qawaem-platform.qawaemaicode.workers.dev';

export function getLicensingApiBase() {
  const fromEnv = process.env.REACT_APP_LICENSING_API_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).trim().replace(/\/$/, '');
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return '';
    }
  }

  return DEFAULT_WORKER;
}

export { DEFAULT_WORKER as LICENSING_WORKER_DEFAULT_URL };
